import './index.less';
import * as React from 'react';
import classnames from 'classnames';
import { Input } from '@beehive/components';
import Select from '../Select';
import PropTypes from 'prop-types';
import messages from 'messages/Components';
import { localPx2rem } from '@mpc/common/src/utils';
export interface FilterRowProps {
  className?: string;
  filters: any[];
  canSearch?: boolean;
  serachProps?: any;
  conditions: any;
  extraContent?: any;
}

export default class FilterRow extends React.PureComponent<FilterRowProps, any> {
  public static contextTypes = {
    intl: PropTypes.object,
  };
  public render() {
    const { intl } = this.context;
    const {
      className,
      filters,
      conditions,
      canSearch,
      serachProps,
      extraContent,
    } = this.props;

    const classes = classnames(className, {
      ['mpc-filter-row']: true,
      ['clearfix']: true,
    });

    return (
      <div className={classes}>
        <div className="pull-right items-inline">
          {
            canSearch && (
              <Input.SearchInput
                size="large"
                placeholder={intl.formatMessage(messages.placeholder)}
                style={{ width: localPx2rem(200) }}
                {...serachProps}
              />
            )
          }
          {filters.map((filter: any) => {
            const condition = conditions[filter.key];
            const { style } = filter;
            return (
              <Select
                className={`filter-${filter.key}`}
                key={`filter-${filter.key}`}
                size="large"
                {...filter}
                style={{ ...style, width: style?.width && localPx2rem(style?.width) }}
                value={condition}
              />
            );
          })}
          {
            extraContent && extraContent()
          }
        </div>
      </div>
    );
  }
}
